/// <reference path="../portal/components/input.js" />
import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Helmet } from "react-helmet"; 
import { Input } from "../portal/components/Input"
import { TextArea } from '../portal/components/TextArea';
import { Modal } from '../portal/components/Modal';
import { AWSWAFCaptchaModal, captchaFetch } from './aws-waf-captcha';

export class ContactUs extends Component {
	static displayName = ContactUs.name

	constructor(props) {
		super(props);
		ContactUs.submitHandler = ContactUs.submitHandler.bind(this);

	}

	static async submitHandler() {

		const form_ = document.getElementById("fm-contactus");

		const formData = new FormData(form_),
			disease = {};

		
		for (const [key, value] of formData) {

			if (value !== "")
				disease[key] = value;
		}
		var submitendpoint = "/api/Smtp";

		try {
			// Sent via captchaFetch, not plain fetch: it sends the request with the
			// token the visitor already holds and renders a CAPTCHA only if the WAF
			// answers with its CAPTCHA action. Whether a challenge appears at all is
			// decided by the WAF rule set, not by this code. Scoped to this one
			// request — an earlier version wrapped every fetch in the app and
			// challenged users just for browsing.
			const response = await captchaFetch(submitendpoint, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(disease),
				headers: {
					"content-type": "Application/json",
					"Accept": "application/json"
				}
			});
			// A WAF / ALB / 5xx body is HTML, not JSON. Without this guard the parse
			// error itself becomes the modal text ("Unexpected token '<'...").
			const data = await response.json().catch(() => ({}));

			Modal.modalDisplay(response.ok, data.message);

		}
		catch (err) {
			// Covers an abandoned or failed CAPTCHA as well as a transport error.
			Modal.modalDisplay(false, err?.message || "Your message could not be sent.");
		}
	}

	static RenderForm() {
		return (
			<div>
				<div className="App">
					<Helmet>
						<title>RetNet: Contact Us</title>
					</Helmet>
				</div>
				<NavMenu />
				<Modal title="Talk to us" okurl="/" failurl="/contactus" />
				<div class="section-center pad-1 w-80 bg-white-smoke border-round">

					<div class="pad-2">
						<form id="fm-contactus">
							<h3 className="text-bluern ">Let us know your thoughts.</h3>
							<br />
							<Input label="First Name" name="firstname" type="Text" cssclass="pad-5p" />
							<Input label="Last Name" name="lastname" type="Text" cssclass="pad-5p" />
							<Input label="Email Address" name="emailAddress" type="Text" cssclass="pad-5p" />
							<Input label="Subject" name="subject" type="Text" cssclass="pad-5p" />
							<TextArea label="What would you like to discuss?" name="message" type="Text" cssclass="pad-5p" />

						</form>
						<button type="button" className="btn btn-primary margin-5" id="form-submit" onClick={e => { e.preventDefault(); this.submitHandler() }}>Submit</button>
					</div>
				</div>

			</div>
		);
	}


	render() {
		var content = ContactUs.RenderForm();

		return (
			<div className="content-w-m">
				{/* Hidden host for the CAPTCHA challenge; shown only during a submit.
				    The SDK script is fetched lazily by captchaFetch, so visitors who
				    never use the form never download it. */}
				<AWSWAFCaptchaModal />
				{
					content
				}
			</div>
		);
	}
}
